import queryClient from '../query-client';
import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { PostResponseBody } from '../types/api-response';
import { FYIConfig } from '../types/fyi-docs';

export type CreateFYIEntityMapRequest = {
    entityId: string;
    fyiEntityName: string;
    fyiEntityId: number;
};

async function createFYIEntityMapping(req: CreateFYIEntityMapRequest): Promise<PostResponseBody<FYIConfig>> {
    const { data } = await api.post(`/fyi-docs/entity-mapping`, req);
    return data;
}

export function useCreateFYIEntityMapping(
    entityId: string
): UseMutationResult<PostResponseBody<FYIConfig>, AxiosError, CreateFYIEntityMapRequest, unknown> {
    return useMutation(createFYIEntityMapping, {
        onSettled: () => {
            queryClient.invalidateQueries(['fyi', 'entities']);
            queryClient.invalidateQueries(['entities', entityId]);
        },
    });
}
